import {CART, ORDER, RESTAURANT} from "./routes.constants";

export const largeScreenMinWidth = 768;
export const largeScreenMediaQuery = `(min-width: ${largeScreenMinWidth}px)`;

export const OrderStatuses = {
	confirmed: 100,
	delivered: 106,
	canceled: 108,
};

export const DefaultValues = {
	locale: 'nb',
	country: 'NO',
};

export const OrderingTypes = {
	pickup: 'pickup',
	delivery: 'delivery',
	dineIn: 'dineIn',
};

export const STORAGE_KEY = 'weorder-state-';
export const LOG_STORAGE_KEY = 'weorder-logs-';


export const MiddlewarePingInterval = 2000;

export const NativePermissionStatuses = {
	NOT_REQUESTED: 'NOT_REQUESTED',
	GRANTED: 'GRANTED',
	GRANTED_WHEN_IN_USE: 'GRANTED_WHEN_IN_USE',
	RESTRICTED: 'RESTRICTED',
	DENIED_ONCE: 'DENIED_ONCE',
	DENIED_ALWAYS: 'DENIED_ALWAYS',
};

export const MainCategoryTypes = {
	info: 'info',
	bookTable: 'book_table',
	bus: 'bus',
	drinks: 'drinks',
	events: 'events',
	food: 'food',
	menu: 'menu',
	member: 'member',
	parking: 'parking',
	ticket: 'ticket',
	merchandise: 'merchandise',
	program: 'program',
	misc: 'misc',
};

export const PaymentTypes = {
	payAtPickup: 1,
	payWithPayex: 2,
	payWithVipps: 3,
	payWithMobilePay: 6,
	payWithCashPoints: 7,
	free: 9,
	payWithStripe: 10,
	payWithInvoice: 11,
	customPaymentType: 12,
	payWithAdyenCard: 14,
	payWithSwish: 15,
	payWithApplePay: 16,
	payWithGooglePay: 17,
};

export const PaymentTypeNames = [
	{
		id: PaymentTypes.payAtPickup,
		appResourceKey: 'pickupPaymentName',
	},
	{
		id: PaymentTypes.payWithPayex,
		appResourceKey: 'payexPaymentName',
	},
	{
		id: PaymentTypes.payWithVipps,
		appResourceKey: 'vippsPaymentName',
	},
	{
		id: PaymentTypes.payWithCashPoints,
		appResourceKey: 'cashPointsPaymentNameTemplate',
	},
	{
		id: PaymentTypes.free,
		appResourceKey: 'freePurchasePaymentName',
	},
	{
		id: PaymentTypes.payWithStripe,
		appResourceKey: 'stripePaymentName',
	},
	{
		id: PaymentTypes.payWithInvoice,
		appResourceKey: 'invoicePaymentName',
	},
	{
		id: PaymentTypes.payWithMobilePay,
		appResourceKey: 'mobilePayPaymentName'
	},
	{
		id: PaymentTypes.payWithAdyenCard,
		appResourceKey: 'adyenCardPaymentName'
	},
	{
		id: PaymentTypes.payWithSwish,
		appResourceKey: 'swishPaymentName'
	},
	{
		id: PaymentTypes.payWithGooglePay,
		appResourceKey: 'googlePayPaymentName'
	},
	{
		id: PaymentTypes.payWithApplePay,
		appResourceKey: 'applePayPaymentName'
	},
];

export const PaymentTypePriorities = {
	[PaymentTypes.payWithStripe]: 1,
	[PaymentTypes.payWithPayex]: 2,
	[PaymentTypes.payWithVipps]: 3,
	[PaymentTypes.payWithMobilePay]: 3,
	[PaymentTypes.payAtPickup]: 4,
	[PaymentTypes.payWithInvoice]: 5,
	[PaymentTypes.payWithCashPoints]: 6,
	[PaymentTypes.free]: 7,
};

export const CardPaymentTypes = [PaymentTypes.payWithPayex, PaymentTypes.payWithStripe, PaymentTypes.payWithAdyenCard];

export const PaymentStatuses = {
	complete: 'COMPLETE',
	cancelled: 'CANCELLED',
	error: 'ERROR',
	pending: 'PENDING',
	authorised: 'Authorised',
	adyenPending: 'Pending',
};

export const CashPointTransactionTypes = {
	TYPE_EARN: 1,
	TYPE_SPEND_BY_WAITER: 2,
	TYPE_SPEND_ON_ORDER: 3,
	TYPE_REFUND: 4,
	TYPE_DELETE_EXPIRED: 5,
	TYPE_RECRUIT_A_FRIEND_REWARD: 6,
};

export const DeliveryTypes = {
	NO_DELIVERY: 0,
	TABLE_DELIVERY: 1,
	HOME_DELIVERY: 2,
};

export const RestaurantTypes = {
	WAITER_INSTALLATION: 0, // null/0: Waiter Installation (default type)
	TABLE_SERVING_CHAIRS: 1, // Table serving, but each order gets its own chair
	ROOM_SERVICE: 2, // RoomService
	PRE_ORDER: 3, // PreOrder
	VIP: 4, // VIP: The guests selects his lounge, and order to it
	FARE: 5, // Fare: The guests selects his stand, and order to it
	EXPRESS_KIOSK: 6, // Express kiosk
	PRE_ORDER_WITH_DELIVERY: 7, // PreOrder with delivery
	TABLE_SERVING: 8, // Table serving
	PRE_ORDER_ONLY_DELIVERY: 9,
	DINE_IN: 10,
	CATERING: 11,
	PRE_ORDER_ONLY_DINE_IN: 12,
};

export const PhoneCodes = [
	{
		name: '+47',
		description: 'Norway',
		value: '+47',
		locales: ['nb', 'nb-no', 'nn', 'nn-no', 'no'],
		numbersWithoutCode: '',
		mask: 'xxx xx xxx',
		maskArray: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
		hasGuide: true,
		isDefault: true,
	},
	{
		name: '+46(0)',
		description: 'Sweden',
		value: '+46',
		locales: ['sv', 'sv-se'],
		mask: 'x xx xx xx xx',
		maskArray: [/\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/],
		hasGuide: true,
	},
	{
		name: '+45',
		description: 'Denmark',
		value: '+45',
		locales: ['da', 'da-dk'],
		mask: 'xx xx xx xx',
		maskArray: [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', ' ', /\d/, /\d/, ' '],
		hasGuide: true,
	},
	{
		name: '+354',
		description: 'Iceland',
		value: '+354',
		locales: ['is', 'is-is'],
		mask: 'xxx xxxx',
		maskArray: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
		hasGuide: true,
	},
	{
		name: '+358(0)',
		description: 'Finland',
		value: '+358',
		locales: ['fi', 'fi-fi'],
		mask: 'xx xxx xx xx',
		maskArray: [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
		hasGuide: false,
	},
	{
		name: '+44',
		description: 'United Kingdom',
		value: '+44',
		locales: ['en-gb'],
		mask: '',
		maskArray: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
		hasGuide: false,
	},
	{
		name: '+49',
		description: 'Germany',
		value: '+49',
		locales: ['de', 'de-de'],
		mask: '',
		maskArray: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
		hasGuide: false,
	},
	{
		name: '+33',
		description: 'France',
		value: '+33',
		locales: ['fr', 'fr-fr'],
		mask: '',
		maskArray: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
		hasGuide: false,
	},
	{
		name: '+34',
		description: 'Spain',
		value: '+34',
		locales: ['es-es'],
		mask: '',
		maskArray: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
		hasGuide: false,
	},
	{
		name: '+32',
		description: 'Belgium',
		value: '+32',
		locales: ['fr-be'],
		mask: '',
		maskArray: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
		hasGuide: false,
	},
	{
		name: 'other',
		description: 'other',
		value: '',
		locales: [''],
		mask: '',
		maskArray: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
		hasGuide: false,
	},
];

export const TermsStatuses = {
	NOT_ACCEPTED: 'NOT_ACCEPTED',
	UPDATED: 'UPDATED',
	ACCEPTED: 'ACCEPTED',
};

export const PageFocusPriorityTargetClass = 'page-focus-priority-target';
export const CashPointsDefaultName = 'Cash Points';

export const PinTypes = {
	WAITER: 'WAITER',
	CARD: 'CARD',
	CARD_CONFIRMATION: 'CARD_CONFIRMATION',
	PHONE_VERIFICATION: 'PHONE_VERIFICATION',
};

export const PinLength = {
	[PinTypes.WAITER]: 2,
	[PinTypes.CARD]: 4,
	[PinTypes.CARD_CONFIRMATION]: 4,
	[PinTypes.PHONE_VERIFICATION]: 4,
};

export const AsapMarker = 'asap';

export const TableNumberCacheLifespan = (1000 * 60 * 60 * 4); // 4 hours

export const PopupPages = {
	RESTAURANT_FIRST_SCREEN: 'first-screen',
	CATEGORY: 'category',
	CART: 'cart',
	REVIEW_ORDER: 'review-order',
};

export const RoutePopupPages = {
	[RESTAURANT]: PopupPages.RESTAURANT_FIRST_SCREEN,
	[CART]: PopupPages.CART,
	[ORDER]: PopupPages.REVIEW_ORDER,
	'/': PopupPages.RESTAURANT_FIRST_SCREEN,
};

export const AdyenReturnModes = {
	URL_STATE_MATCH: "url state match",
	URL_IS_NULL: "url is null",
	STATE_IS_NULL: "state is null",
	URL_STATE_MISMATCH: "url state mismatch"
};
